<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warning/log/listByPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('yewuleixing/mingcheng')">
            <el-select disabled filterable :clearable="true" v-model="$attrs.message.warningTypeId" :max="1" collapse-tags>
              <el-option v-for="(item, index) in alertTypeList" :key="index" :label="item.typeName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('shibai')" :value="0"></el-option>
              <el-option :label="$t('chenggong')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" :loading="yt.loading" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ warningSettingId: $attrs.message.id, orderBy: 'createTime desc', createTimeStart: begin(), createTimeEnd: end() })" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('dianjianxiang', scope.row, '70%')">
              {{ $t('dianjianxiang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 1" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/check/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 点检项 -->
      <template v-if="yt.editObj.action == 'dianjianxiang'">
        <div class="dialog-scroller">
          <check_item :equipment="yt.editObj" ref="checkItem"></check_item>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="submitCheckItem(yt.editObj)" type="primary">
            {{ $t('tijiao') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_early_warning_management_alert_settings_message_view',
  data() {
    return {
      alertTypeList: [],
      columns: [
        {
          label: 'yonghu',
          prop: 'warningUser',
          width: 130
        },
        {
          label: 'tongzhiqudao',
          prop: 'warningChannel',
          width: 130
        },
        {
          label: 'xiaoxi',
          prop: 'msg'
          // width: 130,
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 180
        },
        {
          label: 'zhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('shibai')
            },
            1: {
              color: '#67C23A',
              text: this.$t('chenggong')
            }
          }
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        warningSettingId: this.$attrs.message.id,
        orderBy: 'createTime desc'
      };
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, 'createTimeStart', this.begin());
      this.$set(this.yt.conditions, 'createTimeEnd', this.end());
      this.getWarning();
    }, 300);
  },

  methods: {
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()).getTime();
      return end;
    },
    beforeGet(params) {
      params['createTimeStart'] = this.begin();
      params['createTimeEnd'] = this.end();
      return params;
    },
    getWarning() {
      this.http
        .get('/web/warning/type/page', {
          params: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.alertTypeList = res.data.rows;
          let typeName = '';
          for (let i = 0; i < this.alertTypeList.length; i++) {
            this.alertTypeList[i].typeName = this.alertTypeList[i]['type'] + '/' + this.alertTypeList[i]['name'];
          }
        });
    }
  }
};
</script>
